module.exports = __webpack_public_path__ + "static/media/iep-ui-design02.8858c3e9.png";